module.exports = __webpack_public_path__ + "static/media/messageDayActive.b92781e9.svg";